export function isTerminalJobStatus(status?: string): boolean {
  return status === 'completed' || Boolean(status?.startsWith('error'));
}

export function backoffJobPollDelay(delay: number | null): number | null {
  // A late failure must not restart polling after another check stopped it.
  return delay === null ? null : Math.min(delay * 2, 30000);
}

// Returns a new array, newest `created` first.
export function sortNewestFirst<T extends { created?: string }>(
  jobs: T[],
): T[] {
  return [...jobs].sort((a, b) => {
    const timeA = new Date(a.created as string).getTime();
    const timeB = new Date(b.created as string).getTime();

    // Handle invalid dates - put them at the end
    if (Number.isNaN(timeA) && Number.isNaN(timeB)) return 0;
    if (Number.isNaN(timeA)) return 1;
    if (Number.isNaN(timeB)) return -1;

    return timeB - timeA;
  });
}
